import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

const ImagePreviewLightbox = ({ src, children, className = '' }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className={`${className} cursor-pointer`} onClick={(e) => (setOpen(true), e.stopPropagation())}>
        {children}
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={[{ src }]}
        styles={{
          container: {
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
          },
        }}
        animation={{ fade: true }}
        controller={{ closeOnBackdropClick: true }}
        render={{
          buttonPrev: () => null,
          buttonNext: () => null,
        }}
      />
    </>
  );
};

export default ImagePreviewLightbox;